const TickMark = () => {
  const id = String(performance.now() * Math.random()) // 'quick and dirty' unique identifier - fixes windows bug

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8411 1.85022C14.0274 2.0041 14.0537 2.27986 13.8998 2.46615L5.5873 12.5286C5.5088 12.6237 5.39387 12.6812 5.27076 12.687C5.14765 12.6929 5.02779 12.6465 4.94064 12.5594L0.128141 7.74687C-0.0427136 7.57602 -0.0427136 7.29901 0.128141 7.12815C0.298995 6.9573 0.576005 6.9573 0.746859 7.12815L5.21914 11.6004L13.2252 1.90888C13.3791 1.72259 13.6549 1.69633 13.8411 1.85022Z"
          fill="#000001"
        />
      </mask>
      <g mask={`url(#${id})`}>
        <rect width="14" height="14" fill="currentColor" />
      </g>
    </svg>
  )
}

export default TickMark
